import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { instance } from "api/apiBase";
import { LeadSource } from "views/leads-id/types";
import { ContactFormsSubmenuLeadSource } from "./types";

export const useEligibleContactFormSources = ({
  enabled = true
}: { enabled?: boolean } = {}) => {
  const { data, isLoading } = useQuery({
    queryKey: ["LEAD_SOURCES_LIST"],
    queryFn: () =>
      instance
        .get<{ items: LeadSource[] }>("/portal/v1/boom_crm/lead_sources")
        .then((res) => res.data),
    // Lead sources are near-static; without a staleTime the closed popover unmounts its
    // observer and every menu open refetches the whole list.
    staleTime: 5 * 60_000,
    // Callers on pages that render for non-CRM partners pass enabled: false so those
    // partners don't pay for a list they can never see.
    enabled
  });

  const eligibleSources = useMemo<ContactFormsSubmenuLeadSource[]>(
    () =>
      (data?.items ?? [])
        .filter((source) => source.enable_contact_form)
        .map((source) => ({
          id: source.id,
          name: source.name,
          color: source.color
        })),
    [data]
  );

  return { eligibleSources, isLoading };
};
